import { Grid, Skeleton, Typography, useTheme } from "@mui/material";
import { FormTextFieldSkeleton } from "components/Skeleton";

export function DocumentMetadataFormSectionsSkeleton() {
  const theme = useTheme();

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Skeleton
          variant="text"
          width="100%"
          height={24}
          sx={{ mb: theme.spacing(3) }}
        />
      </Grid>

      {/* Document Title */}
      <Grid size={{ xs: 12 }}>
        <FormTextFieldSkeleton kind="long" />
      </Grid>

      {/* Facilities Section */}
      <Grid size={{ xs: 12 }}>
        <Skeleton
          variant="text"
          width={150}
          height={20}
          sx={{ mb: theme.spacing(1) }}
        />
        <Skeleton
          variant="rounded"
          height={120}
          sx={{ mb: theme.spacing(1) }}
        />
      </Grid>

      {/* Document Type and Program Area */}
      <Grid size={{ xs: 12, sm: 8 }}>
        <FormTextFieldSkeleton />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <FormTextFieldSkeleton />
      </Grid>

      {/* Date Authored and Tags */}
      <Grid size={{ xs: 4 }}>
        <FormTextFieldSkeleton />
      </Grid>
      <Grid size={{ xs: 8 }}>
        <FormTextFieldSkeleton />
      </Grid>

      {/* Description */}
      <Grid size={{ xs: 12 }}>
        <FormTextFieldSkeleton kind="long" />
      </Grid>

      <>
        {/* Document Classification Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Site/Facility Information Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Mailing Address Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Contact Information Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Regulatory Information Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Important Dates Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Financial Information Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Related Documents Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton />
        </Grid>

        {/* Summary Section */}
        <Grid size={{ xs: 12 }}>
          <Skeleton
            variant="text"
            width={200}
            height={24}
            sx={{ mb: theme.spacing(3), mt: theme.spacing(2) }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormTextFieldSkeleton kind="long" />
        </Grid>
      </>
    </>
  );
}
